import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { SanitizeService } from 'src/app/shared/sanitize.service';

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(
      private sanitizer: DomSanitizer
  ) {}

  transform(value: any): SafeHtml {
    if (value != null) {
      return this.sanitizer.bypassSecurityTrustHtml(SanitizeService.sanitizeHtml(value));
    }
    return '';
  }
}
